import { useMutation, useQuery } from "@tanstack/react-query";
import { get, post } from "../../api/client";
import queryClient from "../../config/queryClient";
import { SendNotificationBody } from "../../Constants/Interfaces/payloadInterface/SendNotification.interface";

export const Notifications_key = {
  GET_NOTIFICATIONS: "GET_NOTIFICATIONS",
  GET_NOTIFICATION_CATEGORY_OPTIONS: "GET_NOTIFICATION_CATEGORY_OPTIONS",
  GET_SENT_NOTIFICATIONS: "GET_SENT_NOTIFICATIONS",
};

export const useGetNotificationCategoryeOptions = () =>
  useQuery([Notifications_key.GET_NOTIFICATION_CATEGORY_OPTIONS], () => {
    return get({
      url: "api/v1/notification/options/category",
    });
  });

export const useGetUsersNotifications = () =>
  useQuery([Notifications_key.GET_NOTIFICATIONS], () => {
    return get({ url: "api/v1/notification" });
  });

export const useSendNotifications = ({
  onSuccess,
  onError,
}: {
  onSuccess: () => unknown;
  onError: (error: any) => unknown;
}) =>
  useMutation(
    (data: SendNotificationBody) => {
      return post({ url: "api/v1/notification/send", body: data });
    },
    {
      onSuccess: () => {
        onSuccess();
        queryClient.invalidateQueries({
          queryKey: [Notifications_key.GET_SENT_NOTIFICATIONS],
        });
      },
      onError,
    }
  );

export const useGetSentNotificationLists = ({ page = 1 }: { page: number }) => {
  return useQuery([Notifications_key.GET_SENT_NOTIFICATIONS, page], () => {
    return get({
      url: "api/v1/notification/getSentNotifications",
      params: {
        page,
      },
    });
  });
};
